const UOM_ALLOWED = ['sqft', 'rft', 'unit', 'mm', 'cm', 'inch', 'ft', 'sqm', 'kg', 'litre', 'nos', 'PT', 'Meter'];
const isElectricalWork = (space) => /^electrical work$/i.test(String(space || '').trim());

const normalizedKeyPart = (value) =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');

const normalizedSectionForTemplateKey = (section, bhkType = '') => {
  const normalized = normalizedKeyPart(section);
  if (/^1\s*bhk$/i.test(String(bhkType || '').trim()) && /^master bedroom(?:\s+\d+)?$/.test(normalized)) {
    return 'master bedroom';
  }
  return normalized;
};

const quoteLineTemplateKey = (item, { bhkType = '' } = {}) => {
  const section = item?.space || item?.section || item?.Space || item?.item?.defaultSpace || '';
  const name = item?.itemName || item?.name || item?.item?.name || '';
  return `${normalizedSectionForTemplateKey(section, bhkType)}|${normalizedKeyPart(name)}`;
};

/**
 * Maps Item Master documents (BHK template preset rows) to quote API line payloads.
 */
export function mapItemMasterRowsToQuotePayload(items = []) {
  return items.map((mi) => {
    const L = Number(mi.length) || 0;
    const H = Number(mi.height) || 0;
    const len = L > 0 ? L : 1;
    const ht = H > 0 ? H : 1;
    const qty = len * ht;
    const uom = mi.uom && UOM_ALLOWED.includes(mi.uom) ? mi.uom : 'sqft';
    const rate = Number(mi.rates?.[0]?.clientRate) || 0;
    const isElectrical = isElectricalWork(mi.defaultSpace);
    const material = isElectrical
      ? 'Approx. Points'
      : mi.quoteMaterial || '';
    return {
      item: mi._id,
      itemName: mi.name,
      itemDetails: mi.description || '',
      section: mi.defaultSpace || '',
      space: mi.defaultSpace || '',
      category: material,
      internalFinish: mi.internalFinish || '',
      externalFinish: mi.externalFinish || '',
      length: len,
      height: ht,
      qty,
      uom,
      rate,
      discountType: '%',
      discount: 0,
      _isAddon: isElectrical,
      _addonGroup: isElectrical ? 'Electrical Work' : '',
      _addonEnabled: true,
      gst: 0,
      remarks: '',
      image: mi.image || null,
    };
  });
}

export function mergeMissingTemplateQuoteRows(items = [], templateMasterRows = [], options = {}) {
  const templateRows = mapItemMasterRowsToQuotePayload(templateMasterRows);
  const existingKeys = new Set((items || []).map((item) => quoteLineTemplateKey(item, options)).filter((key) => key !== '|'));
  const missingRows = templateRows.filter((row) => {
    const key = quoteLineTemplateKey(row, options);
    return key !== '|' && !existingKeys.has(key);
  });

  return missingRows.length ? [...(items || []), ...missingRows] : items;
}
